/* CE mega navigation — hover intent + escape handling (Phase 1).
   Progressive enhancement over the native <details>/<summary> shell:
   click and keyboard behavior come from the browser + details-disclosure.js
   (header-menu). This layer only adds pointer hover with an intent delay,
   one-open-at-a-time, and Escape-to-close. If this file fails to load,
   the menu still opens on click. */

(function () {
  var HOVER_OPEN_DELAY = 110;
  var HOVER_CLOSE_DELAY = 180;

  /* --- nav engagement events (Intelligems + GA4 mirror) -------------------
     Same emission pattern as ce-funnel-events.liquid. Register
     'nav_panel_open' and 'nav_click' in Intelligems -> Events Manager
     before using them as test metrics. */
  function ceNavEmit(event, payload) {
    try {
      window.igEvents = window.igEvents || [];
      window.igEvents.push({ event: event });
      window.dataLayer = window.dataLayer || [];
      payload = payload || {};
      payload.event = 'ce_' + event;
      window.dataLayer.push(payload);
    } catch (e) { /* analytics must never break nav */ }
  }

  function ceNavSlot(link) {
    if (link.closest('.ce-mega__cta')) return 'cta_card';
    if (link.closest('.ce-mega__feature')) return 'feature_card';
    if (link.classList.contains('ce-mega__chip')) return 'chip';
    if (link.classList.contains('ce-mega__strip-link')) return 'strip_link';
    if (link.classList.contains('ce-mega__all')) return 'see_all';
    if (link.classList.contains('ce-drawer__device-cta')) return 'device_cta';
    if (link.closest('.ce-drawer__card')) return 'drawer_card';
    if (link.closest('.ce-drawer__pinned')) return 'drawer_pinned';
    if (link.closest('.ce-drawer__links')) return 'drawer_link';
    return 'link';
  }

  function ceNavPanelId(el) {
    var details = el.closest('details');
    return details ? (details.id || '').replace(/^Details-CeMega-|^CeDrawer-/, '') : 'none';
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.ce-nav a, .ce-drawer a');
    if (!link) return;
    ceNavEmit('nav_click', {
      nav_panel: ceNavPanelId(link),
      nav_slot: ceNavSlot(link),
      nav_href: link.getAttribute('href') || '',
      nav_label: (link.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 60),
    });
  }, true);

  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details.open) return;
    if (!details.classList.contains('ce-mega') && !details.classList.contains('ce-drawer__section')) return;
    ceNavEmit('nav_panel_open', {
      nav_panel: (details.id || '').replace(/^Details-CeMega-|^CeDrawer-/, ''),
      nav_surface: details.classList.contains('ce-mega') ? 'desktop' : 'drawer',
    });
  }, true);

  /* --- mobile drawer: one-open accordion + brand-level device shortcut --- */
  document.querySelectorAll('[data-ce-drawer-accordion]').forEach(function (accordion) {
    accordion.addEventListener('toggle', function (event) {
      var opened = event.target;
      if (!opened.open || !opened.classList.contains('ce-drawer__section')) return;
      accordion.querySelectorAll('details.ce-drawer__section[open]').forEach(function (details) {
        if (details !== opened) details.removeAttribute('open');
      });
    }, true);
  });

  var deviceCta = document.querySelector('[data-ce-device-cta]');
  if (deviceCta) {
    // iOS never exposes the model, so detection is brand-level only.
    var ua = navigator.userAgent;
    var label = deviceCta.querySelector('[data-ce-device-cta-label]');
    var target = null;
    if (/iPhone/.test(ua)) {
      target = { href: '/pages/custom-iphone-cases', text: 'Have your iPhone in hand? Start there' };
    } else if (/Pixel/.test(ua)) {
      target = { href: '/pages/custom-pixel-cases', text: 'Have your Pixel in hand? Start there' };
    } else if (/(SM-|Samsung|Galaxy)/i.test(ua)) {
      target = { href: '/pages/custom-samsung-galaxy-cases', text: 'Have your Galaxy in hand? Start there' };
    }
    if (target) {
      deviceCta.setAttribute('href', target.href);
      if (label) label.textContent = target.text;
    }
  }

  /* --- desktop hover intent below: pointer-fine devices only --- */
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function initCeNav(nav) {
    var items = nav.querySelectorAll('.ce-nav__item');

    function closeAll(except) {
      nav.querySelectorAll('details.ce-mega[open]').forEach(function (details) {
        if (details !== except) details.removeAttribute('open');
      });
    }

    items.forEach(function (item) {
      var details = item.querySelector('details.ce-mega');
      if (!details) return;
      var openTimer = null;
      var closeTimer = null;

      item.addEventListener('pointerenter', function () {
        window.clearTimeout(closeTimer);
        openTimer = window.setTimeout(function () {
          closeAll(details);
          details.setAttribute('open', '');
        }, HOVER_OPEN_DELAY);
      });

      item.addEventListener('pointerleave', function () {
        window.clearTimeout(openTimer);
        closeTimer = window.setTimeout(function () {
          details.removeAttribute('open');
        }, HOVER_CLOSE_DELAY);
      });
    });

    nav.addEventListener('keyup', function (event) {
      if (event.key !== 'Escape') return;
      var open = nav.querySelector('details.ce-mega[open]');
      if (!open) return;
      open.removeAttribute('open');
      var summary = open.querySelector('summary');
      if (summary) summary.focus();
    });
  }

  document.querySelectorAll('.ce-nav').forEach(initCeNav);
})();
